// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","1200":"(min-width: 1200px)","root":"BWistpDuI8Vrqz3K8YAf","main":"BoXIW5oR3LjBi8wq_UJr","col":"GvtNhVxG_LtSwoNQVQQY"};